import { isString } from 'lodash-es';

import type { CryptoCurrencyCode } from './crypto';
import { CryptoCurrency } from './crypto';
import type { ICurrency } from './currency.interface';
import type { CurrencyCode } from './fiat';
import { Currency } from './fiat';

export function currencyFactory(currencyCodeOrCurrency: ICurrency | string): ICurrency {
	if (isString(currencyCodeOrCurrency)) {
		try {
			return new Currency(<CurrencyCode> currencyCodeOrCurrency);
		} catch {
			return new CryptoCurrency(<CryptoCurrencyCode> currencyCodeOrCurrency);
		}
	}

	 return currencyCodeOrCurrency;
}

export function currenciesFactory(currencyCodesOrCurrencies: (ICurrency | string)[] = []): ICurrency[] {
	return currencyCodesOrCurrencies.map(currencyFactory);
}
